import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Contact from '@/views/Contact.vue'
import ContactEmprendimiento from '@/views/ContactEmprendimiento.vue'
import NoticiaDetalle from '@/views/NoticiaDetalle.vue'
import Servicios from '@/views/Servicios.vue'
import AuditoriaComponent from '@/components/ServiciosComponent/AuditoriaComponent.vue'
import ImpuestosComponent from '@/components/ServiciosComponent/ImpuestosComponent.vue'
import LaboralComponent from '@/components/ServiciosComponent/LaboralComponent.vue'
import GestionComponent from '@/components/ServiciosComponent/GestionComponent.vue'
import AdminPanel from "../views/AdminArea.vue"
import AdminDashboard from '@/components/AdminComponent/AdminDashboard.vue'
import ClientsManagement from '@/components/AdminComponent/ClientsManagement.vue'
import NoticiasManagement from '@/components/AdminComponent/NoticiasManagement.vue'
import ContactManagement from '@/components/AdminComponent/ContactManagement.vue'
import ConsultoriaManagement from '@/components/AdminComponent/ConsultoriaManagement.vue'
import FileManagement from '@/components/AdminComponent/FileManagement.vue'
import AdminManagement from '@/components/AdminComponent/AdminManagement.vue'
import ClientArea from "../views/ClientArea.vue"
import store from "../store/index.js"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: Contact
  },
  {
    path: '/consultoria',
    name: 'Consultoria',
    component: ContactEmprendimiento
  },
  {
    path: '/noticia/:id',
    name: 'NoticiaDetalle',
    component: NoticiaDetalle,
    props: true
  },
  {
    path: '/servicios',
    name: 'Servicios',
    component: Servicios,
    children: [
      { path: 'auditoria', component: AuditoriaComponent },
      { path: 'impuestos', component: ImpuestosComponent },
      { path: 'laboral',   component: LaboralComponent },
      { path: 'gestion',   component: GestionComponent }
    ]
  },
  {
    path: "/admin",
    name: "AdminPanel",
    component: AdminPanel,
    meta: { requiresAuth: true, role: "admin" },
    children: [
      {
        path: "",
        name: "AdminDashboard",
        component: AdminDashboard,
      },
      {
        path: "clients",
        name: "ClientsManagement",
        component: ClientsManagement,
      },
      {
        path: "noticias",
        name: "NoticiasManagement",
        component: NoticiasManagement,
      },
      {
        path: "contactos",
        name: "ContactManagement",
        component: ContactManagement,
      },
      {
        path: "consultorias",
        name: "ConsultoriaManagement",
        component: ConsultoriaManagement,
      },
      {
        path: "archivos",
        name: "FileManagement",
        component: FileManagement,
      },
      {
        path: "administrador",
        name: "AdminManagement",
        component: AdminManagement,
      },
    ],
  },
  {
    path: "/usuarios",
    name: "ClientArea",
    component: ClientArea,
    meta: { requiresAuth: true, role: "user" },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiredRole = to.meta.role

  if (requiresAuth) {
    const session = await store.dispatch("validateSession")
    const userRole = store.getters.userRole

    if (!session.success) {
      // Not logged in, redirect to login
      next("/login")
    } else if (requiredRole && userRole !== requiredRole) {
      // Logged in but wrong role, redirect to appropriate dashboard
      if (userRole === "admin") {
        next("/admin")
      } else if (userRole === "user") {
        next("/usuarios")
      } else {
        next("/login")
      }
    } else {
      // Authenticated and has correct role
      next()
    }
  } else {
    next()
  }
})

export default router
